import { useMemo } from 'react';

import { Exam } from 'store/payment/paymentAPI';

export const usePaymentSummaryData = (referenceNumber: string, exams: Exam[]) => {
  const activeExams = useMemo(
    () => exams.filter((x) => x.registrationGroupReference === referenceNumber) ?? [],
    [exams, referenceNumber]
  );

  const total = useMemo(() => activeExams.reduce((sum, item) => sum + item.fee, 0), [activeExams]);

  const { preparationCentreName, sessionName, taxRate, currency } = useMemo(
    () => ({
      preparationCentreName: activeExams[0]?.preparationCentreName,
      sessionName: activeExams[0]?.sessionName,
      taxRate: activeExams[0]?.taxRate,
      currency: activeExams[0]?.currencyCode,
    }),
    [activeExams]
  );

  return {
    activeExams,
    total,
    preparationCentreName,
    sessionName,
    taxRate,
    currency
  };
};
